import React from 'react';
import { motion } from 'framer-motion';
import { ease } from '../../styles/GlobalStyles';

interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}

// A short, quiet entrance the first time a block scrolls into view.
const Reveal: React.FC<RevealProps> = ({ children, delay = 0, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 12 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-64px' }}
    transition={{ duration: 0.5, delay, ease: ease.out }}
  >
    {children}
  </motion.div>
);

export default Reveal;
